import Link from 'next/link'

import { PAGE_TYPE, PAGES, STRINGS } from '@/constants/farmbook'
import styles from '@/styles/FarmbookHeader.module.css'

interface Props {
  activePage: PAGE_TYPE
}

interface ButtonProps {
  label: string
  link: string
  isActive: boolean
}

const Button = ({ label, link, isActive }: ButtonProps) => (
  <Link
    href={link}
    className={`py-2.5 px-4 rounded-sm mx-[5px] inline-block ${
      isActive
        ? `text-white ${styles.activeTab} bg-[#6bb51e]`
        : `text-[#495057] bg-transparent hover:bg-[#eeeeee] hover:text-[#1d1e22] ${styles.tab}`
    } transition-all duration-300 cursor-pointer`}
  >
    {label}
  </Link>
)

const FarmbookHeader = ({ activePage }: Props) => (
  <header>
    <h1 className="text-black font-bold font-natosans text-[45px] mb-2.5">
      {STRINGS.FARMBOOK}
    </h1>
    <section className="mt-[30px] mb-2.5">
      {PAGES.map(({ label, link, type }) => (
        <Button
          label={label}
          link={link}
          isActive={type === activePage}
          key={label}
        />
      ))}
    </section>
  </header>
)

export default FarmbookHeader
